import { RESERVED_MODULES, Variant } from '@types';

export const buildProgressBarModuleList = (variant: Variant): string[] => {
  return variant.modules
    .filter((m) => !RESERVED_MODULES.includes(m.name))
    .map((module) => module.name);
};

export const getProgressBarStatus = (
  variant: Variant,
  currentModuleName: string,
  targetModuleName: string
): boolean => {
  const modules = buildProgressBarModuleList(variant);
  const currentIndex = modules.indexOf(currentModuleName);
  const targetIndex = modules.indexOf(targetModuleName);

  if (currentIndex === -1) {
    const variantModuleIndex = variant.modules.findIndex(
      (module) => module.name === currentModuleName
    );
    const targetModuleIndex = variant.modules.findIndex(
      (module) => module.name === targetModuleName
    );

    return targetModuleIndex <= variantModuleIndex;
  }

  return targetIndex <= currentIndex;
};

export const getPercentComplete = (
  variant: Variant,
  currentModuleName: string
): number | undefined => {
  // Hack due to we do not show RESULT OPTIONS green dot in Header
  // But we still need to send 100 (Done) if module submited
  if (currentModuleName === 'MODULE_RESULT_OPTIONS') {
    return 100;
  }

  const modules = buildProgressBarModuleList(variant);
  const currentIndex = modules.indexOf(currentModuleName) + 1;
  const totalModules = modules.length;
  const percentageComplete = parseFloat(
    ((currentIndex / totalModules) * 100).toFixed(2)
  );

  return percentageComplete ? percentageComplete : undefined;
};
